import { createContext, useContext } from "react";

import { ModifierSetsState } from "features/ModifierSets/types";

export const ModifierSetsContext = createContext<ModifierSetsState | null>(null);

export const useModifierSetsContext = (): ModifierSetsState => {
    const state = useContext(ModifierSetsContext);

    if (!state) {
        throw new Error("useModifierSetsContext должен использоваться внутри ModifierSets");
    }

    return state;
};
